import { isEmpty, isArray, isObject } from "lodash";


export const cleanObj = (obj) => {
  for (const key in obj) {
    if (
      obj[key] === null ||
      obj[key] === undefined ||
      obj[key] === "" ||
      (isArray(obj[key]) && isEmpty(obj[key])) ||
      (isObject(obj[key]) && isEmpty(obj[key]))
    ) {
      delete obj[key];
    }
  }

  return obj;
};
